import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

export const TICKET_EVENTS_LOGO = "/Startfish_Black_192.png";

const PROOF_BAR_BG = "#2ecc71";

const useStyles = makeStyles((theme) => ({
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    minHeight: 56,
    padding: theme.spacing(1.5, 2),
    boxSizing: "border-box",
    backgroundColor: "#000",
    background: "#000",
    isolation: "isolate",
    borderBottom: "1px solid rgba(255,255,255,0.12)",
    transition: "box-shadow 0.25s ease",
  },
  headerProof: {
    backgroundColor: PROOF_BAR_BG,
    background: PROOF_BAR_BG,
    borderBottom: "1px solid rgba(0,0,0,0.12)",
  },
  headerScrolled: {
    boxShadow: "0 2px 12px rgba(0,0,0,0.45)",
  },
  headerScrolledProof: {
    boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  headerLogo: {
    height: 48,
    width: "auto",
    display: "block",
    objectFit: "contain",
  },
  headerTitle: {
    color: "#fff",
    fontFamily: "'Montserrat', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 600,
    fontSize: "1.35rem",
    letterSpacing: "0.02em",
  },
  headerTitleProof: {
    color: "#000",
  },
}));

export default function TicketEventsHeader({
  scrolled,
  variant = "ticketHolder",
  proofSurfaceColor,
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const isProofTheme = variant === "proof";
  const proofBg = proofSurfaceColor ?? PROOF_BAR_BG;

  return (
    <header
      className={clsx(
        classes.header,
        isProofTheme && classes.headerProof,
        scrolled &&
          (isProofTheme ? classes.headerScrolledProof : classes.headerScrolled),
      )}
      style={
        isProofTheme ? { backgroundColor: proofBg } : { backgroundColor: "#000" }
      }
    >
      <Box className={classes.headerLeft}>
        <img src={TICKET_EVENTS_LOGO} alt="" className={classes.headerLogo} />
        <Typography
          component="span"
          className={clsx(classes.headerTitle, isProofTheme && classes.headerTitleProof)}
        >
          {t("ticketHolderNav")}
        </Typography>
      </Box>
    </header>
  );
}
